import { render, staticRenderFns } from "./MasterKategori.vue?vue&type=template&id=e6e5ec98&scoped=true"
import script from "./MasterKategori.vue?vue&type=script&lang=js"
export * from "./MasterKategori.vue?vue&type=script&lang=js"
import style0 from "./MasterKategori.vue?vue&type=style&index=0&id=e6e5ec98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5ec98",
  null
  
)

export default component.exports